export function LoadingState() {
  return (
    <div className="state-panel">
      <div className="state-panel__spinner" aria-hidden />
      <p>Loading Texas market data&hellip;</p>
    </div>
  );
}
